const tokens = {
    colors: {
        bg: '#ffffff',
        surface: '#ffffff',
        border: '#e5e7eb',
        text: '#0f172a',
        muted: '#64748b',
        primary: '#0f5bff',
        primaryDark: '#0b46c7',
        overlay: 'rgba(10, 18, 38, 0.72)',
        success: '#0f9d58',
        warning: '#f9a825',
        error: '#d93025',
        info: '#0284c7',
    },
    radius: {
        sm: 8,
        md: 12,
        lg: 16,
    },
    spacing: {
        xs: 0.5,
        sm: 1,
        md: 1.5,
        lg: 2,
        xl: 3,
    },
    shadows: {
        sm: '0 1px 2px rgba(15, 23, 42, 0.08)',
        md: '0 8px 24px rgba(15, 23, 42, 0.06)',
    },
};

export default tokens;
